/* eslint-disable @typescript-eslint/no-var-requires */
import Vue from 'vue';
import VeeValidate from 'vee-validate';
import Errors from '@/helpers/Errors';
const pl = require('vee-validate/dist/locale/pl');

Vue.use(VeeValidate);
Vue.Config('i18n').then((config: any) =>
{
    VeeValidate.Validator.localize('pl', pl);
    VeeValidate.Validator.localize(Vue.i18n.shortLocale());
});

Vue.mixin({
    methods: {
        async validation()
        {
            if (!await this.$validator.validate())
            {
                let errors = new Errors();
                errors.validation(this.$validator.errors);

                throw (() =>
                {
                    return {
                        code: 422,
                        message: null as string,
                        data: {errors: errors.all()},
                        inner: null as any
                    };
                })();
            }
        }
    }
});